import React, { useRef } from "react";
import { Form, Input, Button, Select, Card, Row, Col, Table, Tag, Spin } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link } from "react-router-dom";
import Footer from "Common/Footer";
import useHiring from "Hooks/AdminHooks/useHiring";
import {
  usStates,
  COMPENSATION_RANGES,
  EXPERIENCE_LEVELS,
} from "Common/Static_Property_Data";
import { EmploymentTypeOptions } from "Constants/Enums/EmploymentTypeEnum";

const { Option } = Select;

const JobPostingForm = () => {

    const quillRef = useRef(null);

  const {
    handleBackToList,
    handleAddJob,
    form,
    jobPostings,
    showForm,
    loading,
    addloading,
    onFinish,
    columns,
    jobDescription,
    setJobDescription,
    editingJobId,
    isCompensationEnabled,
    handleBudgetApprovalChange,
    departments,
    jobTitles,
    handleDepartmentChange,
    selectedDepartmentId,
     selectedJobTitle,
    handleJobTitleChange,
    jobTitleDefaultSkills,
    availableSkills,
    skillsLoading,
    skillCreating,
    handleSkillsChange,
     } = useHiring();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        className="card-professional"
        title="Job Postings"
        extra={
          <Link to="/viewcareer" className="underline-link">
            <div style={{ textDecoration: "underline", color: "white" }}>View Career Page</div>
          </Link>
        }
      >
        <Button
          className="btn-primary"
          onClick={showForm ? handleBackToList : handleAddJob}
          style={{ marginBottom: 20 }}
        >
          {showForm ? "Back to Job List" : "Add Job Posting"}
        </Button>

        {!showForm ? (
          <Table
            className="custom-table"
            columns={columns}
            loading={loading}
            dataSource={jobPostings}
            rowKey="key"
          />
        ) : (
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Row gutter={16}>
             <Col span={12}>
                <Form.Item
                  name="departmentId"
                  label="Department"
                  rules={[{ required: true, message: "Please select the department!" }]}
                >
                  <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                    placeholder="Select department"
                    value={selectedDepartmentId || undefined}
                    onChange={handleDepartmentChange}
              
                  >
                    {departments.map((dept) => (
                      <Option key={dept.id} value={String(dept.id)}>
                        {dept.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            <Col span={12}>
             <Form.Item 
               name="jobTitleId"
               label="Select Job Title"
               rules={[{ required: true, message:"Please select the Job Title"}]}
             >
              <Select
              showSearch
              allowClear
              optionFilterProp="children"
              value={selectedJobTitle || undefined}
              onChange={handleJobTitleChange}
              >
               {jobTitles.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
               ))}
              </Select>
             </Form.Item>
            </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="isBudgetApproved"
                  label="Budget Approved"
                  rules={[
                    {
                      required: true,
                      message: "Please select whether the budget is approved!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select budget approval"
                    onChange={handleBudgetApprovalChange}
                  >
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                  </Select>
                </Form.Item>
              </Col>

             
               <Col span={12}>
                <Form.Item
                  name="employmentType"
                  label="Employment Type"
                  rules={[{ required: true, message: "Please select employment type!" }]}
                >
                  <Select placeholder="Select employment type">
                    {EmploymentTypeOptions.map((opt) => (
                      <Option key={opt.value} value={opt.value}>
                        {opt.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="maximumExperience"
                  label="Maximum Experience (years)"
                  rules={[{ required: true, message: "Please select maximum experience!" }]}
                >
                  <Select placeholder="Select experience level">
                    {EXPERIENCE_LEVELS.map((level) => (
                      <Option key={level} value={level}>
                        {level}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="compensation"
                  label="Compensation"
                  rules={[{ required: true, message: "Please input the compensation!" }]}
                >
                  <Select disabled={!isCompensationEnabled} placeholder="Select Compensation">
                    {COMPENSATION_RANGES.map((range) => (
                      <Option key={range} value={range}>
                        {range}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="jobType"
                  label="Job Type"
                  rules={[{ required: true, message: "Please select job type!" }]}
                >
                  <Select placeholder="Select job type">
                    <Option value="On-site">On-site</Option>
                    <Option value="Remote">Remote</Option>
                    <Option value="Hybrid">Hybrid</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="jobLocationType"
                  label="Job Location Type"
                  rules={[{ required: true, message: "Please select job location type!" }]}
                >
                  <Select placeholder="Select job location type">
                    {usStates.map((state) => (
                      <Option key={state} value={state}>
                        {state}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="jobInternalCode"
                  label="Job Internal Code"
                  rules={[{ required: true, message: "Please input the job internal code!" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Job Description">
                  <ReactQuill
                        ref={quillRef}  
                    theme="snow"
                    placeholder="Enter job Description"
                    value={jobDescription}
                    onChange={setJobDescription}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Per Mudassir (May-24): JobPosting skills are JobTitle-scoped.
                Readonly chips show the JobTitle's canonical/required skills
                (always included, can't be removed). The multi-select below
                only carries the recruiter-added extras — BE auto-merges
                both on save. Both sections are hidden until a JobTitle is
                picked since the available pool depends on it. */}
            {selectedJobTitle && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Required Skills (from Job Title)">
                    {skillsLoading ? (
                      <Spin size="small" />
                    ) : jobTitleDefaultSkills.length === 0 ? (
                      <div
                        style={{
                          fontSize: "0.85rem",
                          color: "#8c8c8c",
                          fontStyle: "italic",
                        }}
                      >
                        This Job Title has no default required skills configured.
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {jobTitleDefaultSkills.map((skill) => {
                          // BE may return skill objects shaped as either
                          // {id, name} or {skillId, skillName} depending on
                          // the endpoint. Accept both so we don't render
                          // blank chips when the shape doesn't match.
                          const skillId = skill.id ?? skill.skillId;
                          const skillName = skill.name ?? skill.skillName;
                          return (
                            <Tag
                              key={skillId}
                              color="green"
                              style={{
                                borderRadius: 40,
                                padding: "4px 12px",
                                fontSize: "0.82rem",
                                fontWeight: 500,
                              }}
                            >
                              {skillName}
                            </Tag>
                          );
                        })}
                      </div>
                    )}
                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "#617e9e",
                        marginTop: 6,
                        fontStyle: "italic",
                      }}
                    >
                      These are automatically included with the posting and
                      cannot be removed. Add any extra role-specific skills below.
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            )}

            {selectedJobTitle && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="skills"
                    label="Additional Skills (optional)"
                  >
                    <Select
                      mode="tags"
                      placeholder="Pick from the list or type a new skill to add it"
                      loading={skillsLoading || skillCreating}
                      disabled={skillsLoading}
                      onChange={handleSkillsChange}
                      tokenSeparators={[","]}
                      filterOption={(input, option) =>
                        String(option?.children ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      notFoundContent={
                        skillsLoading ? <Spin size="small" /> : null
                      }
                    >
                      {availableSkills.map((skill) => {
                        // Same dual-shape handling as the chips above.
                        const skillId = skill.id ?? skill.skillId;
                        const skillName = skill.name ?? skill.skillName;
                        return (
                          <Option key={skillId} value={skillId}>
                            {skillName}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Form.Item>
              <Button className="btn-primary" htmlType="submit" loading={addloading} disabled={addloading || skillCreating}>
                {addloading
                  ? editingJobId
                    ? "Updating..."
                    : "Submitting..."
                  : editingJobId
                  ? "Update Job Posting"
                  : "Submit"}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
      <Footer />
    </DashboardLayout>
  );
};

export default JobPostingForm;
